import { useState } from 'react';
import { Combobox, GridAlpha, Notice, useToasts } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { zodValidateField } from '../../../../common/schema/forms';
import { ENGLISH_TEST_TYPE_OPTIONS_LIST } from '../../constants';
import { englishExamTypeSchema } from '../../formSchemas';
import { EnglishTestScoreFields } from './englishTestScores';
import { Field, useSetFieldValues } from '.';

const DEFAULT_ENGLISH_EXAM_VALUES = {
  englishDateOfExam: '',
  englishReadingScore: '',
  englishWritingScore: '',
  englishListeningScore: '',
  englishSpeakingScore: '',
  englishOverallScore: '',
  englishTestScoreDocument: [],
};

const EnglishTestScores = () => {
  const [showNotice, setShowNotice] = useState(true);
  const { t } = useTranslation();
  const toasts = useToasts();
  const setFormFields = useSetFieldValues();

  return (
    <GridAlpha columns="repeat(27, 1fr)" rowGap={6} pb={6}>
      <GridAlpha.Item columnStart={{ xs: 1, md: 2 }} columnEnd={{ xs: 28, md: 27 }}>
        {showNotice && (
          <Notice intent="primary">
            Provide a clear and legible photocopy of the applicant&apos;s test certificate. The
            photocopy needs to be entire with no cut-off at the edges.
            <Notice.CloseButton onClick={() => setShowNotice(false)} />
          </Notice>
        )}
      </GridAlpha.Item>
      <GridAlpha.Item columnStart={{ xs: 1, md: 2 }} columnEnd={{ xs: 28, md: 27 }}>
        <Field
          as={Combobox}
          name="englishTestType"
          label={t('loans.educationSummary.englishTestType')}
          type="text"
          onChange={() => setFormFields(DEFAULT_ENGLISH_EXAM_VALUES)}
          validate={(value: string) => {
            return zodValidateField(englishExamTypeSchema(t), 'englishTestType', value, toasts);
          }}
        >
          {ENGLISH_TEST_TYPE_OPTIONS_LIST.map(option => (
            <Combobox.Option key={option.value} label={option.label} value={option.value} />
          ))}
        </Field>
      </GridAlpha.Item>
      <GridAlpha.Item columnStart={{ xs: 1, md: 2 }} columnEnd={{ xs: 28, md: 27 }}>
        <EnglishTestScoreFields />
      </GridAlpha.Item>
    </GridAlpha>
  );
};

export default EnglishTestScores;
